























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue';
import projectsRepository from '@/services/projectsRepository';
import notificationService from '@/services/notificationService';
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxLabel,
  DxRequiredRule,
} from 'devextreme-vue/form';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxScrollView,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxRequiredRule,
  },
})
export default class ProjectCopyPopup extends Vue {
  @Prop({required: true})
  private projectId!: string;

  private showPopup: boolean = false;
  private saving: boolean = false;

  private dto: IProjectCopyCommand = {
    projectId: '',
    includeMeasurements: true,
    includeQuotations: true,
    includeDocuments: true,
  };

  public show() {
    this.showPopup = true;
  }

  public hide() {
    this.showPopup = false;
  }

  private mounted() {
    this.dto.projectId = this.projectId;
  }

  private async save() {
    try {
      this.saving = true;
      const form: any = this.$refs.form;
      const validationResult = form.instance.validate();

      if (validationResult.isValid) {
        const result = await projectsRepository.duplicateProject(this.dto);
        notificationService.saved();
        this.$router.push({ path: `/projects/${result.data.id}` });
      } else {
        notificationService.invalidForm();
      }
    } catch (err) {
        notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }
}
